module.exports = __webpack_public_path__ + "static/img/2.50d728d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/2.png
// module id = Y4F7
// module chunks = 1